import { render, staticRenderFns } from "./WidgetLastUpdated.vue?vue&type=template&id=7ff39b86&"
import script from "./WidgetLastUpdated.vue?vue&type=script&lang=js&"
export * from "./WidgetLastUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports